import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'; // 引入中文语言包
import 'element-plus/dist/index.css'

import 'element-plus/theme-chalk/index.css';
import * as ElIcons from '@element-plus/icons-vue'; // 引入 Element Plus 图标库
import router from './router';

import store from './store';
import './assets/styles.css';
import {
    createHead
} from '@vueuse/head';
const head = createHead(); // 创建 head 实例
const app = createApp(App)



// 将此代码添加到你的主入口文件（例如 main.js 或 main.ts）
window.onerror = function (message, source, lineno, colno, error) {
    if (message.toString().includes('ResizeObserver loop completed with undelivered notifications')) {
        // 抑制该错误
        return true;
    }
    // 正常处理其他错误
    return false;
};
// 注册所有图标
for (const [key, component] of Object.entries(ElIcons)) {
    app.component(key, component);
}
app.use(router);
app.use(ElementPlus, {
    locale: zhCn, // 设置语言为中文
})
app.use(head); // 使用 head 插件



app.use(store);
app.mount('#app')
